import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import configureStore from './store';

import Login from './containers/Login';
import Verify from './containers/Verify';
import VerifyResult from './containers/VerifyResult';
import BenqBoard from './containers/BenqBoard';
import HiBodyTutorial from './containers/HiBodyTutorial';
import PostSharing from './containers/PostSharing';
import GameInfo from './containers/GameInfo';
import GameList from './containers/GameList';
import Event from './containers/Event';
import PersonalWall from './containers/PersonalWall';
import Party from './containers/Party';
import PartyLoginPage from './containers/PartyLoginPage';
import PartyUpload from './containers/PartyUpload';
import PartyCertificate from './containers/PartyCertificate';
import PageNotFound from './containers/PageNotFound';

import './assets/styles/app.scss';

const { store, history, runSaga } = configureStore();
runSaga();

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        {/* <Route exact path="/" render={() => <Redirect to="/login" />} /> */}
        <Route
          exact
          path="/"
          component={() =>
            window.innerWidth < 992
              ? window.location.assign('/homepage/mobile')
              : window.location.assign('/homepage')
          }
        />
        <Route path="/login" component={Login} />
        <Route path="/verify" component={Verify} />
        <Route path="/verifyResult" component={VerifyResult} />
        <Route path="/benq" component={BenqBoard} />
        <Route path="/post" component={PostSharing} />
        <Route path="/hibodyTutorial" component={HiBodyTutorial} />
        <Route path="/list" component={GameList} />
        <Route path="/game" component={GameInfo} />
        <Route path="/user" component={PersonalWall} />
        <Route path="/event" component={Event} />
        <Route path="/party/login" component={PartyLoginPage} />
        <Route path="/party/upload" component={PartyUpload} />
        <Route path="/party/certificate" component={PartyCertificate} />
        <Route path="/party" component={Party} />
        <Route path="/pageNotFound" component={PageNotFound} />

        {/* <Route component={() => window.location.assign('/homepage/index.html')} /> */}
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app')
);
